
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Mount the app with strict mode for better development experience
createRoot(document.getElementById("root")!).render(<App />);
